import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
// styles
import { DialogStyled } from "./styles";
import { DialogContainerContext } from "./DialogContext";
export var Dialog = function (_a) {
    var children = _a.children, onClose = _a.onClose, _b = _a.isVisible, isVisible = _b === void 0 ? false : _b, _c = _a.isModal, isModal = _c === void 0 ? true : _c, _d = _a.isFullScreen, isFullScreen = _d === void 0 ? false : _d, _e = _a.width, width = _e === void 0 ? "500px" : _e, height = _a.height, zIndex = _a.zIndex, // only needed when isModal = false
    className = _a.className;
    var dialogRef = useRef(null);
    // Handle showing/hiding the modal using native dialog API
    useEffect(function () {
        var dialog = dialogRef.current;
        if (!dialog)
            return;
        // Polyfill for jsdom/test environments that don't support showModal
        if (typeof dialog.showModal !== "function") {
            dialog.showModal = function () {
                this.open = true;
            };
            dialog.show = function () {
                this.open = true;
            };
        }
        if (typeof dialog.close !== "function") {
            dialog.close = function () {
                this.open = false;
            };
        }
        if (isVisible && !dialog.open) {
            if (isModal) {
                dialog.showModal();
            }
            else {
                dialog.show();
            }
        }
        else if (!isVisible && dialog.open) {
            dialog.close();
        }
    }, [isVisible]);
    // Handle ESC key globally (works in iframes/plugins where dialog cancel event may not fire)
    useEffect(function () {
        if (!isVisible)
            return;
        var handleKeyDown = function (e) {
            if (e.key === "Escape") {
                e.preventDefault();
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isVisible, onClose]);
    // Handle backdrop click (for modal dialogs only)
    useEffect(function () {
        var dialog = dialogRef.current;
        if (!dialog || !isModal || !isVisible)
            return;
        var handleClick = function (e) {
            // Check if the click target is the dialog element itself (backdrop)
            // not its children (the actual modal content)
            if (e.target === dialog) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        };
        // Listen on the dialog element - clicks on backdrop will have dialog as target
        dialog.addEventListener("click", handleClick);
        return function () {
            dialog.removeEventListener("click", handleClick);
        };
    }, [isVisible, onClose, isModal]);
    // Don't render the dialog in the DOM until it's needed
    if (!isVisible) {
        return null;
    }
    return (_jsx(DialogContainerContext.Provider, { value: dialogRef, children: _jsx(DialogStyled, { ref: dialogRef, isFullScreen: isFullScreen, "$width": width, "$height": height, zIndex: zIndex, className: className, children: children }) }));
};
export default Dialog;
